import React from 'react';
import styled from 'styled-components';
import Leaderboards from './Leaderboards';

const PageContainer = styled.div`
    min-height: calc(100vh - 80px); /* Adjust for header height */
    background-color: #f5f5f5;
`;

function LeaderboardsPage({ currentUser }) {
    return (
        <PageContainer>
            <Leaderboards currentUser={currentUser} />
        </PageContainer>
    );
}

export default LeaderboardsPage; 